export { BatchDetails as default } from '@/screens/batches/Batch'
